import React from 'react';
export function Terms() {
  return <div className="pt-20" data-id="element-1543">
      {/* Hero */}
      <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-gradient-to-br from-gray-50 to-white" data-id="element-1544">
        <div className="container-custom" data-id="element-1545">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1546">
            <h1 className="mb-6" data-id="element-1547">HIRE Advantage Agreement</h1>
            <p className="text-body-large text-gray-600" data-id="element-1548">
              Terms and Conditions of Service
            </p>
          </div>
        </div>
      </section>

      {/* Agreement Content */}
      <section className="section-padding bg-white" data-id="element-1549">
        <div className="container-custom" data-id="element-1550">
          <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1551">
            {/* Preamble */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-l-4 border-amber" data-id="element-1552">
              <p className="leading-relaxed" data-id="element-1553">
                This HIRE Advantage Agreement (together with all applicable
                Services Order(s) and addenda, executed hereunder, the
                "Agreement") is entered into by and between the HIRE entity
                identified in a Service Order ("HIRE") and the counterparty to
                that Service Order ("Client") and contains the terms and
                conditions that govern Client's access to and use of the Scope
                of Services (see defined below). This agreement is effective
                when Client executes a Services Order referencing this Agreement
                (the "Effective Date").
              </p>
            </div>

            {/* 1. Introduction & Recitals */}
            <div className="mb-12" data-id="element-1554">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1555">
                1. Introduction & Recitals
              </h2>
              <p className="leading-relaxed" data-id="element-1556">
                HIRE provides high-performance recruiting solutions designed to
                scale businesses. Under this Agreement, HIRE will deliver its
                Proprietary Recruiting System, which combines advanced
                recruiting services with consulting, coaching, and ongoing
                support to optimize candidate experience, onboarding, and
                retention.
              </p>
            </div>

            {/* 2. Definitions */}
            <div className="mb-12" data-id="element-1557">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1558">
                2. Definitions
              </h2>

              <div className="space-y-4" data-id="element-1559">
                <div data-id="element-1560">
                  <p className="font-semibold text-navy mb-1" data-id="element-1561">Campaign:</p>
                  <p className="leading-relaxed" data-id="element-1562">
                    A set of 1–10 marketing ads used within a geographic region.
                  </p>
                </div>

                <div data-id="element-1563">
                  <p className="font-semibold text-navy mb-1" data-id="element-1564">
                    Campaign Launch:
                  </p>
                  <p className="leading-relaxed" data-id="element-1565">
                    Date when applicant tracking system is live (system of
                    record for Client to track Recruits) and targeted ad
                    campaigns are posted.
                  </p>
                </div>

                <div data-id="element-1566">
                  <p className="font-semibold text-navy mb-1" data-id="element-1567">Ad Spend:</p>
                  <p className="leading-relaxed" data-id="element-1568">
                    The amount invested by the Client for advertising campaigns,
                    paid to a third-party.
                  </p>
                </div>

                <div data-id="element-1569">
                  <p className="font-semibold text-navy mb-1" data-id="element-1570">
                    Proprietary Recruiting System:
                  </p>
                  <p className="leading-relaxed" data-id="element-1571">
                    HIRE's exclusive methods, processes, training materials, and
                    technology used by HIRE.
                  </p>
                </div>

                <div data-id="element-1572">
                  <p className="font-semibold text-navy mb-1" data-id="element-1573">Recruit:</p>
                  <p className="leading-relaxed" data-id="element-1574">
                    A candidate who is sourced by HIRE Campaigns and completed
                    the HIRE-provided onboarding form or Client Rep Agreement.
                  </p>
                </div>

                <div data-id="element-1575">
                  <p className="font-semibold text-navy mb-1" data-id="element-1576">
                    Qualified HIRE:
                  </p>
                  <p className="leading-relaxed" data-id="element-1577">
                    A Qualified HIRE has completed their first day participating
                    in either Field sales activity, or Formal entry into the
                    Client's sales training program (e.g., sales school),
                    whichever occurs first.
                  </p>
                </div>

                <div data-id="element-1578">
                  <p className="font-semibold text-navy mb-1" data-id="element-1579">Active HIRE:</p>
                  <p className="leading-relaxed" data-id="element-1580">
                    A Qualified HIRE who has completed their first 30 days with
                    the Client and remains actively engaged with the Client's
                    business as a seller of Client's wares or services.
                  </p>
                </div>

                <div data-id="element-1581">
                  <p className="font-semibold text-navy mb-1" data-id="element-1582">
                    Qualified HIRE Date:
                  </p>
                  <p className="leading-relaxed" data-id="element-1583">
                    The date the Recruit completed their first day participating
                    in either Field sales activity, or Formal entry into the
                    Client's sales training program (e.g., sales school),
                    whichever occurs first.
                  </p>
                </div>

                <div data-id="element-1584">
                  <p className="font-semibold text-navy mb-1" data-id="element-1585">
                    Active HIRE Date:
                  </p>
                  <p className="leading-relaxed" data-id="element-1586">
                    The date the Qualified HIRE completed their first 30 days
                    with the Client.
                  </p>
                </div>

                <div data-id="element-1587">
                  <p className="font-semibold text-navy mb-1" data-id="element-1588">Services:</p>
                  <p className="leading-relaxed" data-id="element-1589">
                    Services listed in section 3.
                  </p>
                </div>

                <div data-id="element-1590">
                  <p className="font-semibold text-navy mb-1" data-id="element-1591">
                    Services Order:
                  </p>
                  <p className="leading-relaxed" data-id="element-1592">
                    The document by which Client orders, and HIRE agrees to
                    provide, Services Pursuant to this Agreement.
                  </p>
                </div>
              </div>
            </div>

            {/* 3. Scope of Services */}
            <div className="mb-12" data-id="element-1593">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1594">
                3. Scope of Services
              </h2>
              <p className="leading-relaxed mb-6" data-id="element-1595">
                As part of this Agreement, HIRE shall provide the following
                services, aligned to the fee categories in Section 4:
              </p>

              <div className="space-y-6" data-id="element-1596">
                <div data-id="element-1597">
                  <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1598">
                    Build
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1599">
                    <li data-id="element-1600">Custom Recruiting System Buildout</li>
                    <li data-id="element-1601">ATS Integration & Tracking</li>
                    <li data-id="element-1602">Initial Setup of Automated Applicant Communication</li>
                    <li data-id="element-1603">
                      Initial Configuration of Live Data & Dashboard Access
                    </li>
                  </ul>
                </div>

                <div data-id="element-1604">
                  <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1605">
                    Platform
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1606">
                    <li data-id="element-1607">
                      Access to HIRE's proprietary recruiting platform,
                      integrations, dashboards, and reporting tools
                    </li>
                    <li data-id="element-1608">Ongoing Ad Performance Analysis & Adjustments</li>
                    <li data-id="element-1609">Monthly Executive Recruiting Review</li>
                    <li data-id="element-1610">
                      Ongoing Recruiting Best Practice Training (including
                      webinars)
                    </li>
                    <li data-id="element-1611">
                      Hiring Manager Support (1:1 training, auditing, coaching)
                    </li>
                    <li data-id="element-1612">Performance Benchmarking</li>
                  </ul>
                </div>

                <div data-id="element-1613">
                  <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1614">
                    Campaign
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1615">
                    <li data-id="element-1616">
                      Targeted Ad Campaigns (copywriting, branding, posting job
                      listings)
                    </li>
                    <li data-id="element-1617">Pre-Screening & Pre-Qualification</li>
                    <li data-id="element-1618">Done-for-You Screening Calls</li>
                    <li data-id="element-1619">
                      Pre-Qualified Interviews Booked into Client's Calendar
                    </li>
                  </ul>
                </div>

                <div data-id="element-1620">
                  <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1621">
                    Recruiter
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-1622">
                    When the Recruiter service is selected, HIRE replaces the
                    Client's in-house recruiter function. Under this service:
                  </p>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1623">
                    <li data-id="element-1624">
                      HIRE provides a recruiter aligned with the Client's
                      campaigns.
                    </li>
                    <li data-id="element-1625">
                      The Client no longer conducts hiring meetings with a
                      hiring manager or recruiter.
                    </li>
                    <li data-id="element-1626">
                      Instead, the Client accepts or rejects candidates provided
                      by HIRE prior to the candidate attending Sales School.
                    </li>
                  </ul>
                </div>

                <div data-id="element-1627">
                  <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1628">
                    Placement
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1629">
                    <li data-id="element-1630">Candidate Experience Optimization</li>
                    <li data-id="element-1631">Onboarding System Buildout</li>
                    <li data-id="element-1632">Early Retention Strategy Development</li>
                    <li data-id="element-1633">
                      Virtual Sales Schools and related training/consulting to
                      support candidate readiness and retention
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mt-6 bg-gray-50 rounded-lg p-4 border-l-4 border-amber" data-id="element-1634">
                <p className="text-sm leading-relaxed" data-id="element-1635">
                  <strong data-id="element-1636">General Terms of Service Delivery:</strong> Services
                  are delivered in a commercially reasonable manner and may be
                  adjusted by HIRE to reflect evolving best practices. Certain
                  services, such as virtual sales schools, may be subject to
                  schedule availability.
                </p>
              </div>
            </div>

            {/* 4. Payment Terms */}
            <div className="mb-12" data-id="element-1637">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1638">
                4. Payment Terms
              </h2>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1639">
                4.1 Product Fees
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1640">
                Client agrees to pay the following Product Fees in accordance
                with the amounts and rates set forth in the applicable Services
                Order:
              </p>

              <div className="space-y-4 mb-6" data-id="element-1641">
                <div data-id="element-1642">
                  <p className="font-semibold text-navy mb-1" data-id="element-1643">
                    Build (One-Time):
                  </p>
                  <p className="leading-relaxed" data-id="element-1644">
                    A one-time setup fee, invoiced and due upon execution of the
                    Services Order.
                  </p>
                </div>

                <div data-id="element-1645">
                  <p className="font-semibold text-navy mb-1" data-id="element-1646">
                    Platform (Recurring Monthly, Includes One Campaign):
                  </p>
                  <p className="leading-relaxed" data-id="element-1647">
                    A recurring monthly fee that provides ongoing access to
                    HIRE's proprietary recruiting platform, integrations,
                    dashboards, reporting tools, and related support services.
                    The Platform Fee includes management of one (1) campaign.
                    The first Platform Fee is due upon execution of the Services
                    Order; the second Platform Fee is due one (1) month after
                    project launch; each subsequent Platform Fee is due on the
                    monthly anniversary of the second payment.
                  </p>
                </div>

                <div data-id="element-1648">
                  <p className="font-semibold text-navy mb-1" data-id="element-1649">
                    Recruiter (Recurring Monthly):
                  </p>
                  <p className="leading-relaxed" data-id="element-1650">
                    A recurring monthly fee per recruiter provided by HIRE.
                    Recruiter quantity must equal the number of active campaigns
                    under management. The first Recruiter Fee is due upon
                    execution of the Services Order; the second Recruiter Fee is
                    due one (1) month after project launch; each subsequent
                    Recruiter Fee is due on the monthly anniversary of the
                    second payment.
                  </p>
                </div>

                <div data-id="element-1651">
                  <p className="font-semibold text-navy mb-1" data-id="element-1652">
                    Additional Campaign(s) (Recurring Monthly):
                  </p>
                  <p className="leading-relaxed" data-id="element-1653">
                    A recurring monthly fee per additional campaign beyond the
                    one included in the Platform Fee. The first Campaign Fee is
                    due upon execution of the Services Order; the second
                    Campaign Fee is due one (1) month after project launch; each
                    subsequent Campaign Fee is due on the monthly anniversary of
                    the second payment.
                  </p>
                </div>

                <div data-id="element-1654">
                  <p className="font-semibold text-navy mb-1" data-id="element-1655">
                    Placement (Recurring Monthly, Billed in Arrears):
                  </p>
                  <p className="leading-relaxed" data-id="element-1656">
                    A recurring monthly fee based on the number of Active
                    Recruits in the prior monthly cycle, billed in arrears.
                    Recurring Placement Fees commence on the Qualified Recruit
                    Date and continue monthly for up to twelve (12) months from
                    each Active Recruit Date. These Placement Fees survive
                    termination of this Agreement and remain payable for all
                    Active Recruits delivered prior to termination.
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1657">
                4.2 Payment Schedule
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-1658">
                <li data-id="element-1659">All payments due upon receipt.</li>
                <li data-id="element-1660">
                  The One-Time Build & Implementation Fee, as well as the first
                  month's Platform Fee and Managed Campaign Fee(s), are due upon
                  execution of this Agreement and before HIRE begins the
                  campaign and account build.
                </li>
                <li data-id="element-1661">
                  Subsequent Platform Fee and Managed Campaign Fee(s) are due
                  one (1) month after the ads/campaign begins and on the same
                  day each month thereafter (no later than the 28th of the
                  month).
                </li>
                <li data-id="element-1662">
                  Recurring Placement Fees are invoiced and due at the end of
                  each monthly cycle based on the number of Active HIREs. Client
                  hereby authorizes HIRE to automatically process such payments
                  via ACH transfer or credit card on file. Payments made by
                  credit card shall be subject to a processing surcharge of
                  three percent (3%).
                </li>
              </ul>

              <div className="bg-amber/10 rounded-lg p-4 border-l-4 border-amber mb-6" data-id="element-1663">
                <p className="font-semibold text-navy mb-2" data-id="element-1664">
                  Late Payment Penalties:
                </p>
                <p className="leading-relaxed" data-id="element-1665">
                  A five-day grace period applies. After five days, unpaid
                  amounts will incur a 5% monthly interest fee. Client agrees
                  HIRE may suspend all services and withhold all deliverables
                  immediately upon nonpayment, without liability, until account
                  is current.
                </p>
              </div>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1666">
                4.3 Campaign Scope & Expansion
              </h3>
              <div className="space-y-4 mb-6" data-id="element-1667">
                <div data-id="element-1668">
                  <p className="font-semibold text-navy mb-1" data-id="element-1669">
                    Number of Contracted Campaigns:
                  </p>
                  <p className="leading-relaxed" data-id="element-1670">
                    The Client and HIRE agree that this Agreement covers _____
                    campaign(s), with each campaign defined as up to ten (10)
                    managed ads in a particular geographic region.
                  </p>
                </div>

                <div data-id="element-1671">
                  <p className="font-semibold text-navy mb-1" data-id="element-1672">
                    Additional Campaign Expansion:
                  </p>
                  <p className="leading-relaxed" data-id="element-1673">
                    The Client may expand by adding campaigns beyond the
                    initially agreed number. Each additional campaign will be
                    billed at $1,500/month, contingent on HIRE's capacity and
                    mutual agreement.
                  </p>
                </div>

                <div data-id="element-1674">
                  <p className="font-semibold text-navy mb-1" data-id="element-1675">
                    Campaign Reduction:
                  </p>
                  <p className="leading-relaxed" data-id="element-1676">
                    Campaigns may be reduced or paused on a monthly basis with
                    written notice, provided that each campaign operates on a
                    minimum thirty (30)-day cycle. Any reduction shall be
                    prorated and aligned with the Client's monthly billing
                    cycle.
                  </p>
                </div>

                <div data-id="element-1677">
                  <p className="font-semibold text-navy mb-1" data-id="element-1678">
                    Campaign Reallocations & Adjustments:
                  </p>
                  <ul className="list-disc ml-6 space-y-2 mt-2" data-id="element-1679">
                    <li data-id="element-1680">
                      Ad spend may be reallocated across campaigns in real time,
                      based on performance and hiring needs.
                    </li>
                    <li data-id="element-1681">
                      If a campaign is removed and replaced with an entirely new
                      campaign, the Client must confirm with HIRE prior to
                      implementation.
                    </li>
                  </ul>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1682">
                4.4 Ad Spend Responsibility
              </h3>
              <p className="leading-relaxed" data-id="element-1683">
                The Client is solely responsible for all advertising costs ("Ad
                Spend") incurred in connection with campaigns under this
                Agreement. Ad Spend is billed directly by the applicable job
                boards or advertising platforms to the Client and is not
                included in HIRE's fees.
              </p>
            </div>

            {/* 5. Performance Commitment */}
            <div className="mb-12" data-id="element-1684">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1685">
                5. Performance Commitment
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-1686">
                If, within the first 90 days of Campaign Launch AND the Client
                spends at least $12,000 in total advertising, HIRE guarantees:
              </p>
              <div className="bg-amber/10 rounded-lg p-6 border-l-4 border-amber mb-4" data-id="element-1687">
                <p className="leading-relaxed mb-2" data-id="element-1688">
                  <strong data-id="element-1689">Either:</strong> At least twenty-five (25) Qualified
                  HIREs; or
                </p>
                <p className="leading-relaxed" data-id="element-1690">
                  At least twenty (20) Qualified HIREs and there will be a
                  minimum of seven (7) additional Recruits who are active, in
                  good standing, and scheduled to start within the subsequent
                  two (2) weeks.
                </p>
              </div>
              <p className="leading-relaxed mb-4" data-id="element-1691">
                If this condition is not met within 90 days, HIRE will continue
                providing campaign services at no additional Platform or
                Campaign Fee until the guarantee is fulfilled. The Client
                remains responsible for:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-1692">
                <li data-id="element-1693">Advertising costs, and</li>
                <li data-id="element-1694">Recurring Placement Fees for all Active HIREs</li>
              </ul>
              <p className="leading-relaxed" data-id="element-1695">
                This commitment excludes circumstances where Client delays
                interviews, onboarding, or hiring decisions, or fails to provide
                required branding, materials, or access within agreed timelines
                (Section 6).
              </p>
            </div>

            {/* 6. Client Responsibilities */}
            <div className="mb-12" data-id="element-1696">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1697">
                6. Client Responsibilities
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-1698">The Client shall:</p>
              <ul className="list-disc ml-6 space-y-2" data-id="element-1699">
                <li data-id="element-1700">
                  Have personnel to support interviews, hiring, and onboarding.
                </li>
                <li data-id="element-1701">
                  Allocate proper time for onboarding activities and ongoing
                  meetings.
                </li>
                <li data-id="element-1702">
                  Provide branding materials (logo, tagline, color scheme).
                </li>
                <li data-id="element-1703">Collaborate with HIRE on culture video production.</li>
                <li data-id="element-1704">Set up a dedicated company email for Indeed access.</li>
                <li data-id="element-1705">
                  Provide Google Calendar details for recruiters/screeners.
                </li>
                <li data-id="element-1706">Report sales statistics weekly for Recruits.</li>
                <li data-id="element-1707">
                  Provide necessary materials within seven (7) days of contract
                  execution.
                </li>
              </ul>
            </div>

            {/* 7. Confidentiality & Proprietary Rights */}
            <div className="mb-12" data-id="element-1708">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1709">
                7. Confidentiality & Proprietary Rights
              </h2>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1710">
                7.1 Confidentiality
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1711">
                The Client agrees all aspects of HIRE's Proprietary Recruiting
                System are confidential and shall not be disclosed, copied, or
                reverse-engineered.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1712">
                7.2 Data Use
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1713">
                Applicant data is for the Client's internal use only. HIRE
                reserves the right to use campaign data (including
                non-anonymized data where appropriate) for case studies,
                marketing, and analysis, provided Client business interests are
                not compromised.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1714">
                HIRE may reference Client's name and logo in general marketing
                materials unless Client objects in writing.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1715">
                7.3 Non-Compete & Non-Circumvention
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1716">
                The Client shall not, directly or indirectly:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-1717">
                <li data-id="element-1718">
                  Replicate, use, or modify HIRE's recruiting system,
                  advertisements, or proprietary materials outside of this
                  Agreement;
                </li>
                <li data-id="element-1719">
                  Transfer, disclose, or make available HIRE's recruiting
                  system, advertisements, or proprietary materials to any third
                  party, including competitors, agencies, or contractors; or
                </li>
                <li data-id="element-1720">
                  Engage in any conduct that has the purpose or effect of
                  circumventing HIRE's role in providing recruiting services.
                </li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-1721">
                This restriction applies for a period of two (2) years, or for
                the full duration that Placement Fees remain payable under
                Section 4.1, whichever is longer, after termination of this
                Agreement.
              </p>
              <p className="leading-relaxed" data-id="element-1722">
                Violations entitle HIRE to seek injunctive relief and liquidated
                damages equal to twelve (12) months of lost value.
              </p>
            </div>

            {/* 8. Term, Renewal, and Termination */}
            <div className="mb-12" data-id="element-1723">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1724">
                8. Term, Renewal, and Termination
              </h2>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1725">8.1 Term</h3>
              <p className="leading-relaxed mb-6" data-id="element-1726">
                This Agreement shall remain in effect for an initial term of
                ninety (90) days, beginning on the date of Campaign Launch.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1727">
                8.2 Renewal
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1728">
                After the initial term, the Agreement renews month-to-month
                unless either party provides at least fourteen (14) days'
                written notice of non-renewal.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1729">
                8.3 Early Termination for Convenience (28-Day Guarantee)
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1730">
                Notwithstanding any other provision of this Agreement, the
                Client may terminate for convenience at any time within the
                first twenty-eight (28) days following Campaign Launch. In such
                event:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-1731">
                <li data-id="element-1732">
                  HIRE shall refund one hundred percent (100%) of the Build &
                  Implementation Fee
                </li>
                <li data-id="element-1733">No Recurring Placement Fees shall be due.</li>
              </ul>
              <p className="leading-relaxed" data-id="element-1734">
                Upon such termination, both parties are released from all
                further obligations.
              </p>
            </div>

            {/* 9. Dispute Resolution & Governing Law */}
            <div className="mb-12" data-id="element-1735">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1736">
                9. Dispute Resolution & Governing Law
              </h2>
              <p className="leading-relaxed" data-id="element-1737">
                This Agreement shall be governed by Arizona law. Disputes shall
                first be resolved through mediation.
              </p>
            </div>

            {/* 10. Indemnification & Limitation of Liability */}
            <div className="mb-12" data-id="element-1738">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1739">
                10. Indemnification & Limitation of Liability
              </h2>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1740">
                Indemnification by Client:
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1741">
                Client indemnifies HIRE against claims arising from misuse of
                the system, hiring decisions, or breach.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1742">
                Indemnification by HIRE:
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1743">
                HIRE indemnifies Client against claims resulting from gross
                negligence or intentional misconduct.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1744">
                Limitation of Liability:
              </h3>
              <p className="leading-relaxed" data-id="element-1745">
                HIRE's liability shall not exceed the total fees paid by Client
                in the three months preceding a claim. HIRE shall not be liable
                for indirect or consequential damages.
              </p>
            </div>

            {/* 11. Amendments & Notices */}
            <div className="mb-12" data-id="element-1746">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1747">
                11. Amendments & Notices
              </h2>
              <p className="leading-relaxed" data-id="element-1748">
                All amendments must be in writing and signed by both parties.
                Notices must be in writing.
              </p>
            </div>

            {/* 12. Acknowledgment */}
            <div className="mb-12" data-id="element-1749">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1750">
                12. Acknowledgment and Acceptance
              </h2>
              <p className="leading-relaxed" data-id="element-1751">
                By signing below, both parties acknowledge they have read,
                understood, and agreed to the terms of this Agreement.
              </p>
            </div>

            {/* EXHIBIT A */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-2 border-navy" data-id="element-1752">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1753">
                EXHIBIT A – TERMINATION & EXIT PROVISIONS
              </h2>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1754">
                Termination Conditions:
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-1755">
                <li data-id="element-1756">
                  This Agreement shall renew on a month-to-month basis after the
                  initial ninety (90) day term, unless either party provides
                  fourteen (14) days' written notice of non-renewal.
                </li>
                <li data-id="element-1757">
                  The Client may terminate for convenience within the first
                  twenty eight (28) days of execution pursuant to Section 8.3 of
                  this Agreement.
                </li>
                <li data-id="element-1758">
                  HIRE reserves the right to terminate immediately if the Client
                  fails to make payments or breaches confidentiality
                  obligations.
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1759">
                Financial Obligations Upon Termination:
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-1760">
                <li data-id="element-1761">
                  The Client remains responsible for all outstanding invoices up
                  to the termination date.
                </li>
                <li data-id="element-1762">
                  Recurring Placement Fees remain payable for all Active HIREs,
                  up to twelve (12) months from the Active HIRE Date.
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1763">
                Survival of Obligations:
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-1764">
                Confidentiality, proprietary rights, and all payment obligations
                (including Recurring Placement Fees) shall survive termination.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1765">
                Post-Termination Use of Intellectual Property & Data:
              </h3>
              <ul className="list-disc ml-6 space-y-2" data-id="element-1766">
                <li data-id="element-1767">
                  The Client shall cease use of any proprietary materials,
                  recruiting systems, training programs, or strategies developed
                  by HIRE.
                </li>
                <li data-id="element-1768">
                  Any materials provided by HIRE (including advertisements,
                  branding, or process structures) shall not be used to
                  replicate services independently or with a third-party vendor.
                </li>
                <li data-id="element-1769">
                  HIRE retains ownership of all data, processes, and
                  confidential information provided during the term.
                </li>
              </ul>
            </div>

            {/* EXHIBIT B */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-2 border-navy" data-id="element-1770">
              <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-1771">
                EXHIBIT B – INDEMNIFICATION & LIMITATION OF LIABILITY
              </h2>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1772">
                Indemnification by the Client:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1773">
                The Client agrees to indemnify, defend, and hold harmless HIRE
                from any claims, damages, or liabilities arising from the
                Client's misuse of the system, hiring decisions, or breach of
                contract.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1774">
                The Client assumes full responsibility for compliance with
                employment laws and regulations.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1775">
                Indemnification by HIRE:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1776">
                HIRE shall indemnify the Client against claims resulting from
                gross negligence or intentional misconduct in delivering
                services under this Agreement.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1777">
                HIRE is not responsible for hiring outcomes, employee
                performance, misconduct, retention results, or legal disputes
                related to employment practices.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1778">
                Limitation of Liability:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1779">
                In no event shall HIRE's total liability exceed the total fees
                paid by the Client in the three (3) months preceding the claim.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1780">
                HIRE shall not be liable for indirect, incidental, or
                consequential damages, including loss of profits, business
                interruptions, or reputational harm.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-1781">
                Nothing in this section shall limit the Client's obligation to
                pay Recurring Placement Fees or other amounts due under this
                Agreement.
              </p>

              <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-1782">
                Force Majeure:
              </h3>
              <p className="leading-relaxed" data-id="element-1783">
                Neither party shall be held liable for delays or failures in
                performance due to causes beyond their reasonable control,
                including but not limited to natural disasters, labor strikes,
                government actions, or technological failures. Payment
                obligations incurred prior to the force majeure event shall
                remain enforceable and are not excused.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="section-padding bg-gray-50" data-id="element-1784">
        <div className="container-custom" data-id="element-1785">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1786">
            <h2 className="mb-6" data-id="element-1787">Questions About This Agreement?</h2>
            <p className="text-body-large mb-8 leading-relaxed" data-id="element-1788">
              We're happy to discuss any questions or concerns you have about
              our service agreement.
            </p>
            <a href="/book-call" className="inline-block bg-amber hover:bg-amber-dark text-navy font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1789">
              Schedule a Call →
            </a>
          </div>
        </div>
      </section>
    </div>;
}